import {useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import BillingProfile from "./billing-profile";
import {setWorkspaceGraphBillingProfiles, upsertWorkspaceBillingProfile, workspaceGraphSelectors} from "../../system/workspace-graph-slice";

export function useBillingProfile() {
    const dispatch = useDispatch();
    const billingProfiles = useSelector(workspaceGraphSelectors.billingProfiles);

    const getBillingProfiles = useCallback(async (workspaceId) => {
        if (!workspaceId) return [];
        const model = new BillingProfile();
        const data = await model.getAll({populate: "*"});
        const items = data?.data || [];
        dispatch(setWorkspaceGraphBillingProfiles(items));
        return items;
    }, [dispatch]);
    const getBillingProfile = async (documentId) => {
        const model = new BillingProfile();
        const data = await model.getById(documentId);
        if (data?.data) dispatch(upsertWorkspaceBillingProfile(data.data));
        return data?.data;
    };
    const saveBillingProfile = useCallback(async (payload) => {
        const model = new BillingProfile();
        const data = await model.saveMine(payload);
        if (data?.data) dispatch(upsertWorkspaceBillingProfile(data.data));
        return data?.data || null;
    }, [dispatch]);
    return {billingProfiles, getBillingProfiles, getBillingProfile, saveBillingProfile};
}
